import { gql, useApolloClient } from "@apollo/client";
import { CopyAddressFragmentDoc } from "../types";
gql `
fragment CopyAddress on Fulfillment {
  address {
    ...ChooseSubscriptionScreenAddress
  }
  shippingNotes
}
`;
export const useCopyAddress = ({ sourceId, targetId }) => {
    const client = useApolloClient();
    return () => {
        const sourceAddress = client.readFragment({
            id: `Fulfillment:${sourceId}`,
            fragment: CopyAddressFragmentDoc,
            fragmentName: "CopyAddress",
        });
        console.log(sourceAddress);
        client.writeFragment({
            id: `Fulfillment:${targetId}`,
            fragment: CopyAddressFragmentDoc,
            fragmentName: "CopyAddress",
            data: {
                address: Object.assign({}, sourceAddress.address),
                shippingNotes: sourceAddress.shippingNotes
            }
        });
    };
};
